import { render } from "./TohCards.vue?vue&type=template&id=d9e9536a&scoped=true"
import script from "./TohCards.vue?vue&type=script&lang=js"
export * from "./TohCards.vue?vue&type=script&lang=js"

import "./TohCards.vue?vue&type=style&index=0&id=d9e9536a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9e9536a"]])

export default __exports__